import { Button, Col, Form, OverlayTrigger, Row, Image, Tooltip, Table } from "react-bootstrap";
import { HeaderRegister } from "../../../components/HeaderRegister";
import { EventService } from "../../../services/event.service";
import { useEffect, useRef, useState } from "react";
import { ToastService } from "../../../services/toast.service";
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from "react-router-dom";
import { FieldArray, Formik } from "formik";
import * as yup from 'yup';
import { TransporterModel } from "../../../models/transporter.model";
import { BranchModel } from "../../../models/branch.model";
import { LocaleModel } from "../../../models/locale.model";
import TransporterService from "../../../services/transporter.service";
import BranchService from "../../../services/branch.service";
import LocaleService from "../../../services/locale.service";
import { EventModel } from "../../../models/event.model";
import _ from "lodash";
import DatePicker from "react-datepicker";
//import "react-datepicker/dist/react-datepicker.css";
import storageService from "../../../services/storage.service";
import moment from "moment";
import EquipmentService from "../../../services/equipment.service";
import EventPeriodService from "../../../services/eventPeriod.service";
import EventBlacklistService from "../../../services/eventBlacklist.service";
import { DatasetModel } from "../../../models/dataset.model";

export const EventRegister = () => {
  const { id } = useParams<{ id?: string }>();
  const [initialValues, setInitialValues] = useState({
    id: 0,
    reason: '',
    adjustValue: 0,
    localeId: undefined,
    transporterId: undefined,
    branchId: undefined,
    eventPeriod: [],
    eventBlacklist: [],
    periodAt: null,
    periodTo: null,
    repeatOnYear: [],
    isActive: true
  });

  const user = storageService.getUser();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const formRef = useRef();
  const history = useHistory();
  const [transporters, setTransporters] = useState<TransporterModel[]>();
  const [branches, setBranches] = useState<BranchModel[]>();
  const [locales, setLocale] = useState<LocaleModel[]>();

  const initialize = async () => {
    await LocaleService.getAll().then(async (response: any) => {
      setLocale(response.result);
    });

    await TransporterService.getAll().then(async (response: any) => {
      if (response.success === true && response.result) {
        let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'transporter' }));
        const sort = (d?.data ?? []).sort((a, b) =>
          a.fullName.localeCompare(b.fullName)
        );
        setTransporters(sort);
      } 
    });

    await BranchService.getAll().then((response: any) => {
      if (response.success === true && response.result) {
        let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'branch' }));
        const sort = (d?.data ?? []).sort((a, b) =>
          a.fullName.localeCompare(b.fullName)
        );
        setBranches(sort);
      } 
    });

    if (Number(id)) {
      let result: any = {};
      const response: any = await EventService.getById(id);
      if (response.success) {
        result = response.result;
        let filters:any = {
          locale_id: [result.localeId],
        };

        if(result.transporterId){
          filters = {
            ...filters,
            transporter_id: [result.transporterId]
          };
        }

        if(result.branchId){
          filters = {
            ...filters,
            branch_id: [result.branchId],
          };
        }
        const responseBlacklist: any = await EventBlacklistService.getByEventId(id);
        const responseEquipments: any = await EquipmentService.getList({
          datasets: [{
            dataset: 'equipment',
            pagination: {
              page_number: 1,
              records_pages: 999999999,
              total_pages: 0,
              total_records: 0
            },
            sort: {
              field: '',
              orientation: 'asc'
            },
            filters
          }]
        });
        if (responseEquipments.success && responseEquipments.result) {
          let d: any = _.last(_.filter(responseEquipments.result.datasets, { dataset: 'equipment' }));

          if (responseBlacklist.success) {
            result.eventBlacklist = responseBlacklist.result;
          }
          result.eventBlacklist = _.map(d.data, (value) => {
            let editBlacklist = -1;
            if (responseBlacklist.success && responseBlacklist.result && responseBlacklist.result.length > 0) {
              editBlacklist = _.findIndex(responseBlacklist.result, { 'equipmentId': value.id });
            }
            return { ...value, check: (editBlacklist !== -1 ? [] : ['on']) };
          });
        }



        const responsePeriod: any = await EventPeriodService.getByEventId(id);
        if (responsePeriod.success) {
          result.eventPeriod = responsePeriod.result;
        }
        setInitialValues(result);
      }
    }


  };

  useEffect(() => {
    initialize();
  }, []);

  const schema = yup.object().shape({
    reason: yup.string().required(t('REQUIRED')),
    localeId: yup.string().required(t('REQUIRED')),
    periodAt: yup.string().nullable()
  });

  const submitFormik = () => {
    if (formRef && formRef.current) {
      let current: any = formRef.current;
      current.handleSubmit();
    }
  }

  const saveEvent = (event: EventModel) => {
    setLoading(true);
    if (event.id > 0) {
      EventService.update(event).then((response: any) => {
        if (response.success) {
          ToastService.success(t('EVENT.UPDATED'));
          history.push('/Event');
        }
      }).finally(() => {
        setLoading(false);
      });
    } else {
      EventService.insert(event).then((response: any) => {
        if (response.success) {
          ToastService.success(t('EVENT.INSERTED'));
          history.push('/Event');
        }
      }).finally(() => {
        setLoading(false);
      });
    }
  };

  return (
    <>
      <HeaderRegister title={`${t('EVENT.REASON')} | ${window.location.hash.includes("add") ? t("REGISTRATION") : t("EDITION")}`} path={"/Event"} submitForm={submitFormik} isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}/>


      <Formik
        enableReinitialize={true}
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, actions) => {
          let valuesToSave = _.clone(values);
          valuesToSave.eventBlacklist = _.map(_.filter(valuesToSave.eventBlacklist, (value) => { return value.check.length === 0 }), (value) => { return { equipmentId: value.id, eventId: valuesToSave.id } });
          valuesToSave.eventPeriod = _.map(valuesToSave.eventPeriod, (value) => { return { ...value, eventId: valuesToSave.id } });

          if (!valuesToSave.eventPeriod || valuesToSave.eventPeriod.length === 0) {
            ToastService.error(t('EVENT.VALIDATION_PERIOD_EMPTY'))
          } else {
            saveEvent(valuesToSave);
          }
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          setValues,
          setFieldError,
          setFieldValue,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} xl={12}>
                <Row className="align-items-center">
                  <Col sm={12} md={8} lg={8} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='reason'
                          id='reason'
                          type='text'
                          placeholder={t('EVENT.REASON')}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.reason && !!errors.reason}
                          value={values.reason}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.reason}
                        </Form.Control.Feedback>
                        <Form.Label>{t('EVENT.REASON')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={4} lg={4} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='adjustValue'
                          id='adjustValue'
                          type='text'
                          placeholder={t('EVENT.ADJUST_VALUE')}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.adjustValue && !!errors.adjustValue}
                          value={values.adjustValue}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.adjustValue}
                        </Form.Control.Feedback>
                        <Form.Label>{t('EVENT.ADJUST_VALUE')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={3} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='localeId'
                          name='localeId'
                          isInvalid={touched.localeId && !!errors.localeId}
                          disabled={isLoading}
                          onChange={(event) => {
                            setValues(prevValues => ({
                              ...prevValues,
                              localeId: event.target.value,
                              transporterId: '',
                              branchId: ''
                            }));
                            EquipmentService.getList({
                              datasets: [{
                                dataset: 'equipment',
                                pagination: {
                                  page_number: 1,
                                  records_pages: 999999999,
                                  total_pages: 0,
                                  total_records: 0
                                },
                                sort: {
                                  field: '',
                                  orientation: 'asc'
                                },
                                filters: {
                                  localeId: [event.target.value ? event.target.value : undefined]
                                }
                              }]
                            }).then((response: any) => {
                              if (response.success === true && response.result) {
                                let d: any = _.last(_.filter(response.result.datasets, { dataset: 'equipment' }));
                                setValues(prevValues => ({
                                  ...prevValues,
                                  eventBlacklist: _.map(d.data, (value) => { return { ...value, check: ['on'] } })
                                }));
                              }
                            });
                          }}
                          value={values.localeId}
                          aria-label={t("EVENT.LOCALE")}>
                          <option value="">{t("EVENT.LOCALE")}</option>
                          {_.map(locales, (l: LocaleModel) => {
                            return <option key={l.id} value={l.id}>{l.name}</option>
                          })}

                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.localeId}
                        </Form.Control.Feedback>
                        <label htmlFor="localeId">{t("EVENT.LOCALE")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={3} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='transporterId'
                          name='transporterId'
                          isInvalid={touched.transporterId && !!errors.transporterId}
                          disabled={isLoading}
                          onChange={(event) => {
                            setValues(prevValues => ({
                              ...prevValues,
                              transporterId: event.target.value,
                              branchId: ''
                            }));
                            EquipmentService.getList({
                              datasets: [{
                                dataset: 'equipment',
                                pagination: {
                                  page_number: 1,
                                  records_pages: 999999999,
                                  total_pages: 0,
                                  total_records: 0
                                },
                                sort: {
                                  field: '',
                                  orientation: 'asc'
                                },
                                filters: {
                                  locale_id: [values.localeId ? Number(values.localeId) : undefined],
                                  transporter_id: [event.target.value ? Number(event.target.value) : undefined]
                                }
                              }]
                            }).then((response: any) => {
                              if (response.success === true && response.result) {
                                let d: any = _.last(_.filter(response.result.datasets, { dataset: 'equipment' }));
                                setValues(prevValues => ({
                                  ...prevValues,
                                  eventBlacklist: _.map(d.data, (value) => { return { ...value, check: ['on'] } })
                                }));
                              }
                            });
                          }}
                          value={values.transporterId}
                          aria-label={t("EVENT.TRANSPORTERNAME")}>
                          <option value="">{t("EVENT.TRANSPORTERNAME")}</option>
                          {_.map(_.filter(transporters, function (t) { return t.localeId.toString() === values.localeId?.toString() || values.localeId?.toString() === "0"; }), (l: TransporterModel) => {
                            return <option key={l.id} value={l.id}>{l.fullName}</option>
                          })}

                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.transporterId}
                        </Form.Control.Feedback>
                        <label htmlFor="transporterId">{t("EVENT.TRANSPORTERNAME")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={3} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='branchId'
                          name='branchId'
                          isInvalid={touched.branchId && !!errors.branchId}
                          disabled={isLoading}
                          onChange={(event) => {
                            setValues(prevValues => ({
                              ...prevValues,
                              branchId: event.target.value,
                            }));
                            EquipmentService.getList({
                              datasets: [{
                                dataset: 'equipment',
                                pagination: {
                                  page_number: 1,
                                  records_pages: 999999999,
                                  total_pages: 0,
                                  total_records: 0
                                },
                                sort: {
                                  field: '',
                                  orientation: 'asc'
                                },
                                filters: {
                                  locale_id: [values.localeId ? Number(values.localeId) : undefined],
                                  transporter_id: [values.transporterId ? Number(values.transporterId) : undefined],
                                  branch_id: [event.target.value ? Number(event.target.value) : undefined]
                                }
                              }]
                            }).then((response: any) => {
                              if (response.success === true && response.result) {
                                let d: any = _.last(_.filter(response.result.datasets, { dataset: 'equipment' }));
                                setValues(prevValues => ({
                                  ...prevValues,
                                  eventBlacklist: _.map(d.data, (value) => { return { ...value, check: ['on'] } })
                                }));
                              }
                            });
                          }}
                          value={values.branchId}
                          aria-label={t("EVENT.BRANCH")}>
                          <option value="">{t("EVENT.BRANCH")}</option>
                          {_.map(_.filter(branches, function (b) { return b.transporterId.toString() === values.transporterId?.toString(); }), (l: BranchModel) => {
                            return <option key={l.id} value={l.id}>{l.fullName}</option>
                          })}

                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.branchId}
                        </Form.Control.Feedback>
                        <label htmlFor="branchId">{t("EVENT.BRANCH")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={3} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='isActive'
                          name='isActive'
                          isInvalid={touched.isActive && !!errors.isActive}
                          disabled={isLoading}
                          onChange={(event) => {
                            setValues(prevValues => ({
                              ...prevValues,
                              isActive: event.target.value === "true"
                            }));
                          }}
                          value={values.isActive.toString()}
                          aria-label={t("EVENT.STATUS")}>
                          <option value="true">{t("EVENT.ACTIVE")}</option>
                          <option value="false">{t("EVENT.INACTIVE")}</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.isActive}
                        </Form.Control.Feedback>
                        <label htmlFor="isActive">{t("EVENT.STATUS")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                </Row>
                <FieldArray
                  name="eventPeriod"
                  render={arrayHelpers => (
                    <Row>
                      <Col sm={12} md={3} lg={2} className="mb-4">
                        <Form.Group>
                          <Form.Label>{t('EVENT.PERIOD')}</Form.Label>
                          <DatePicker
                            onChange={(e) => {
                              setValues({ ...values, periodAt: e[0], periodTo: e[1] });
                            }}                            
                            className={'form-control'}
                            selectsRange={true}                            
                            startDate={values.periodAt}
                            endDate={values.periodTo}
                            dateFormat={storageService.getUser().locale.formatDate.replaceAll('DD', 'dd')}
                            isClearable={true}
                            disabled={_.findIndex(values.eventPeriod, { repeatOnYear: true }) > -1}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.periodAt}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={3} lg={2} className="mb-4 mt-auto">
                        <Form.Group>
                          <Form.Check
                            type='checkbox'
                            id={`repeatOnYear`}
                            name={`repeatOnYear`}
                            label={t('EVENT.REPEATONYEAR')}
                            onChange={handleChange}
                            checked={values.repeatOnYear?.length > 0}
                            disabled={values.eventPeriod?.length > 0}
                          />

                        </Form.Group>
                      </Col>
                      <Col sm={12} md={2} lg={1} className="mt-auto mb-4">
                        <Button disabled={isLoading || _.findIndex(values.eventPeriod, { repeatOnYear: true }) > -1} onClick={() => {
                          if (!values.periodAt || !values.periodTo) {
                            ToastService.error(t('EVENT.VALIDATION_PERIOD'))
                          } else {
                            arrayHelpers.push(_.clone({ periodAt: values.periodAt, periodTo: values.periodTo, repeatOnYear: values.repeatOnYear?.length > 0 }));
                            setFieldValue('periodAt', null);
                            setFieldValue('periodTo', null);
                            setFieldValue('repeatOnYear', []); 
                            // setValues({
                            //   ...values,
                            //   periodAt: null,
                            //   periodTo: null,
                            //   repeatOnYear: []
                            // });
                          }
                        }}>
                          <span>{t('BUTTON_ADD')}</span>
                        </Button>
                      </Col>

                      <label>{t('EVENT.PERIODS')}:</label>
                      <br />
                      <br />
                      <Row className='mb-3'>
                        <Col lg={4} md={6} sm={12}>
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>{t('EVENT.PERIOD')}</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {values.eventPeriod && values.eventPeriod.length > 0 && (
                                values.eventPeriod.map((period, index) => (
                                  <tr key={index}>
                                    <td>
                                      <label>{`${t('EVENT.AT')} ${moment(values.eventPeriod[index].periodAt).format(storageService.getUser().locale.formatDate)} ${t('EVENT.TO')} ${moment(values.eventPeriod[index].periodTo).format(storageService.getUser().locale.formatDate)}`}
                                        &nbsp;
                                        {values.eventPeriod[index].repeatOnYear ? `- ${t('EVENT.REPEATONYEAR')}` : ''}
                                        &nbsp;
                                      </label>
                                    </td>
                                    <td>
                                      <Button disabled={isLoading} onClick={() => { arrayHelpers.remove(index) }}>
                                        <span>{t('DELETE')}</span>
                                      </Button>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>

                    </Row>
                  )}
                />

                <FieldArray
                  name="eventBlacklist"
                  render={arrayHelpers => (
                    <Row>
                      <label>{t('EVENT.BLACKLIST')}:</label>
                      <br />
                      <br />
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>{t('EVENT.EQUIPMENT')}</th>
                            <th>{t('EVENT.BRANCH')}</th>
                            <th>{t('EVENT.ADDRESS')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.eventBlacklist && values.eventBlacklist.length > 0 && (
                            values.eventBlacklist.map((blacklist, index) => (
                              <tr key={index}>
                                <td>
                                  <Form.Group>
                                    <Form.Check
                                      type='checkbox'
                                      name={`eventBlacklist.${index}.check`}
                                      onChange={handleChange}
                                      checked={blacklist.check.length > 0}
                                    />

                                  </Form.Group>
                                </td>
                                <td>
                                  {blacklist.codeEquipment}
                                </td>
                                <td>
                                  {blacklist.branchNickname}
                                </td>
                                <td>
                                  {blacklist.addressStreet} -
                                  {blacklist.addressCity} -
                                  {blacklist.addressState} -
                                </td>
                              </tr>

                            ))
                          )}
                        </tbody>
                      </Table>
                    </Row>
                  )}
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
